import { defineRecipe } from '@chakra-ui/react';

export default defineRecipe({
  base: {
    bg: 'brandSecondary.solid',
  },
});
